module.exports = __webpack_public_path__ + "media/audios/kid/lesson_10/audio_tpc10-46f091bc9d7621a12e0da603dfed99ec.m4a";